function FooterCorp() {
  return (
    <footer
      style={{
        width: '100%',
        textAlign: 'center',
        padding: '15px 0',
        marginTop: 'auto',
      }}
    >
      <div style={{ fontSize: '11px', color: '#64748b' }}>
        <h6 style={{ margin: 0, fontSize: '11px', fontWeight: '600' }}>
          DTDeI 2026 sistemadegestion@isepsantafe.net.ar
        </h6>
      </div>
    </footer>
  );
}

export default FooterCorp;